import { format, parse } from 'date-fns'
import isEmpty from 'lodash/isEmpty'

export default function useUtils() {
  const formatProductPreorderDate = (date?: string | null) => {
    if (!date) { return '' }
    return format(parse(date, 'yyyy-MM-dd', new Date()), 'MM.yyyy')
  }

  const getParsedAdditionalFields = (
    additionalFields: Record<string, any>,
    additionalFieldsForm: Record<string, any>,
  ) => {
    if (isEmpty(additionalFields)) {
      return {}
    }

    const sortObjectByKeys = (obj: Record<string, any>) => {
      return Object.keys(obj)
        .sort((a, b) => a.localeCompare(b))
        .reduce((acc: Record<string, any>, key) => {
          acc[key] = obj[key]
          return acc
        }, {})
    }

    if (!isEmpty(additionalFieldsForm)) {
      const parsedFields: Record<string, any> = {
        ...additionalFields,
      }
      for (let key in parsedFields) {
        const options = additionalFieldsForm[key]?.options
        const matchingOption = options?.find((option) => option.value === parsedFields[key]?.value)
        if (matchingOption) {
          parsedFields[key]!.value = matchingOption.text
        }
      }
      return sortObjectByKeys(parsedFields)
    }
    return sortObjectByKeys(additionalFields)
  }

  return { formatProductPreorderDate, getParsedAdditionalFields }
}
